module.exports = __webpack_public_path__ + "img/serifnew_box18.47a00289.jpg";